import { useEffect, useRef } from 'react'
import { Html5QrcodeScanner } from 'html5-qrcode'

interface Props {
  onScan: (qrToken: string) => void
  active: boolean
}

const SCANNER_ID = 'qr-scanner-container'
const DEBOUNCE_MS = 2000

export function QrScanner({ onScan, active }: Props) {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null)
  const lastScanRef = useRef<number>(0)

  useEffect(() => {
    if (!active) return

    const scanner = new Html5QrcodeScanner(
      SCANNER_ID,
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        rememberLastUsedCamera: true,
      },
      /* verbose= */ false,
    )

    scannerRef.current = scanner

    scanner.render(
      (decodedText) => {
        const now = Date.now()
        if (now - lastScanRef.current < DEBOUNCE_MS) return
        lastScanRef.current = now
        onScan(decodedText)
      },
      (errorMessage) => {
        // Scan errors are expected (frame without QR code) — suppress
        void errorMessage
      },
    )

    return () => {
      scanner.clear().catch(() => {
        // ignore cleanup errors
      })
      scannerRef.current = null
    }
  }, [active, onScan])

  return (
    <div>
      <div id={SCANNER_ID} />
    </div>
  )
}
